import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { Post } from './Post';
import { loadData } from './Post.LoadData';

export default withOverrideLegacy(Post, loadData);
